import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import { connect } from 'react-redux';
import { motion } from 'framer-motion';
import { TBankerHeader } from '../Components/TBankerHeader';
import { MajorAccountsFooter } from '../Components/MajorAccountsFooter';
import { TViteProofCard } from './TViteProofCard';
import { TVitePurchase } from './TVitePurchase';
import { browserHistory } from 'react-router';
import * as Request from '../tgccRequest';

const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textTransform: 'uppercase',
    backgroundColor: 'rgb(244, 250, 255)',
    margin: '0px auto',
    borderRadius: '20px',
    '@media (max-width: 768px)': {
        margin: '0 10px', // Add margin on the sides for mobile view
        borderRadius: '10px', // Optional: Reduce border radius for mobile view
        width: '95%',
    },
};

/**
 * CED page shell: full viewport width on mobile.
 * Avoids wrapperStyle's 95%/side margins and .campusTviteBox fixed widths (375/350px)
 * that leave white gutters and make the page look like a floating card.
 */
const cedPageWrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textTransform: 'uppercase',
    backgroundColor: 'rgb(244, 250, 255)',
    margin: '0px auto',
    borderRadius: 0,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    '@media (max-width: 900px)': {
        margin: 0,
        borderRadius: 0,
        width: '100%',
        maxWidth: '100%',
    },
};

const contentStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
    padding: '15px',
    background: Tgcc.Styles.cardBackground,
    boxShadow: Tgcc.Styles.boxShadow,
};

const woStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontSize: '45px',
    letterSpacing: '12px',
    fontWeight: 'lighter',
    textTransform: 'uppercase',
    color: 'rgba(88,88,88,0.8)',
};

const statusStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontSize: '25px',
    letterSpacing: '8px',
    fontWeight: 100,
    textTransform: 'uppercase',
    marginBottom: '10px',
    color: 'rgba(88,88,88,0.7)',
};

const btnStyle: React.CSSProperties = {
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'CenturyGothic',
    fontSize: '28px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    background: 'rgb(103,186,175)',
    padding: '5px 40px',
    boxShadow: Tgcc.Styles.boxShadow,
    marginTop: '5px',
    marginBottom: '10px',
};

const labelStyle: React.CSSProperties = {
    display: 'flex',
    color: Tgcc.Styles.darkTextColor,
    margin: '10px',
    fontSize: '16px',
    flexBasis: '230px',
    fontFamily: 'Lulo',
    '@media(max-width:375px)': {
        fontSize: '14px',
    },
    '@media (max-width:320px)': {
        fontSize: '11px',
    },
};

const codeStyle: React.CSSProperties = {
    display: 'flex',
    backgroundColor: Tgcc.Styles.buttonBackground,
    color: 'black',
    opacity: 0.6,
    fontSize: '16px',
    textAlign: 'center',
    flexBasis: '175px',
    padding: '0 10px',
    fontFamily: 'Lulo',
    '@media(max-width:375px)': {
        fontSize: '14px',
    },
    '@media (max-width:320px)': {
        fontSize: '12px',
    },
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    width: '400px',
    maxWidth: '90%',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
};

const dashHdrLineR: React.CSSProperties = {
    width: '180px',
    backgroundColor: '#E9E6E6',
    height: '2px',
    display: 'inline-block',
    marginBottom: '8px',
    marginRight: '10px',
};

const dashHdrLineL: React.CSSProperties = {
    width: '180px',
    backgroundColor: '#E9E6E6',
    height: '2px',
    display: 'inline-block',
    marginBottom: '8px',
    marginLeft: '5px',
};

const dashText: React.CSSProperties = {
    display: 'inline-block',
    letterSpacing: '0.3em',
    fontSize: '26px',
    fontFamily: 'Lulo',
    color: '#616060',
};

const createAcc: React.CSSProperties = {
    textAlign: 'center',
    marginTop: '10vh',
};

const headerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#1a365d', // Darker, more professional blue
    color: '#FFFFFF',
    fontSize: '28px', // Larger, more prominent font
    fontWeight: 'bold',
    padding: '25px 20px', // More vertical padding
    textTransform: 'uppercase',
    letterSpacing: '1px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Subtle shadow for depth
    borderBottom: '3px solid #3182ce', // Accent border
};

const subHeaderStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f7fafc', // Even lighter, cleaner background
    color: '#1a202c', // Darker, more prominent text
    fontSize: '18px', // Larger font for better readability
    fontWeight: '600', // Semi-bold for more emphasis
    padding: '25px 20px', // More padding for better visual presence
    textTransform: 'none', // Remove uppercase for better readability
    letterSpacing: '0.3px', // Slightly tighter letter spacing
    lineHeight: '1.5', // Better line spacing for readability
    textAlign: 'center',
    borderBottom: '2px solid #e2e8f0', // More prominent separator
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)', // Subtle shadow for depth
};

/** CED brand tokens (catalog strip + industrial header). */
const CED_NAVY = '#1a365d';

/** CED header — live circuit / industrial signal. */
const CED_C_FIELD = '#121416';
const CED_C_FIELD_EDGE = '#1c1f24';
const CED_C_AMBER = '#f0a020';
const CED_C_AMBER_DIM = 'rgba(240, 160, 32, 0.45)';
const CED_C_STEEL = '#c8cdd4';
const CED_C_STEEL_MUTED = 'rgba(200, 205, 212, 0.62)';

const cedCircuitWrapStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: '22px',
    textAlign: 'left',
    textTransform: 'none',
    padding: '20px 32px 16px',
    overflow: 'hidden',
    background: `linear-gradient(180deg, ${CED_C_FIELD} 0%, ${CED_C_FIELD_EDGE} 100%)`,
    borderBottom: `1px solid ${CED_C_AMBER_DIM}`,
    boxShadow: 'inset 0 1px 0 rgba(240, 160, 32, 0.08)',
    '@media (max-width: 900px)': {
        flexDirection: 'column',
        gap: '4px',
        padding: '10px 14px 8px',
    },
};

const cedCircuitMainStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '1 1 auto',
    minWidth: 0,
};

const cedCircuitContactStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    gap: '8px',
    flex: '0 0 auto',
    width: 'auto',
    minWidth: 0,
    paddingLeft: '24px',
    borderLeft: `1px solid ${CED_C_AMBER_DIM}`,
    '@media (max-width: 900px)': {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        width: '100%',
        paddingLeft: 0,
        paddingTop: '6px',
        borderLeft: 'none',
        borderTop: `1px solid ${CED_C_AMBER_DIM}`,
        gap: '4px 14px',
    },
};

const cedCircuitContactItemStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '4px',
    flex: '0 1 auto',
    width: 'auto',
    minWidth: 0,
    maxWidth: '100%',
    '@media (max-width: 900px)': {
        alignItems: 'flex-start',
    },
};

const cedCircuitContactLabelStyle: React.CSSProperties = {
    margin: 0,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: '10px',
    fontWeight: 400,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    color: CED_C_AMBER,
    '@media (max-width: 900px)': {
        fontSize: '8px',
        letterSpacing: '0.18em',
    },
};

const cedCircuitContactLinkStyle: React.CSSProperties = {
    margin: 0,
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.04em',
    lineHeight: 1.25,
    color: CED_C_STEEL,
    textDecoration: 'none',
    ':hover': {
        color: CED_C_AMBER,
    },
    ':focus': {
        outline: `1px solid ${CED_C_AMBER}`,
        outlineOffset: '3px',
    },
    '@media (max-width: 900px)': {
        fontSize: '11px',
        letterSpacing: '0.02em',
        lineHeight: 1.2,
        wordBreak: 'break-word',
    },
};

const cedCircuitGridStyle: React.CSSProperties = {
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    opacity: 0.35,
    backgroundImage:
        'linear-gradient(rgba(200, 205, 212, 0.04) 1px, transparent 1px),' +
        'linear-gradient(90deg, rgba(200, 205, 212, 0.04) 1px, transparent 1px)',
    backgroundSize: '48px 48px',
};

const cedCircuitStatusStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '0 0 0',
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: '11px',
    fontWeight: 400,
    letterSpacing: '0.28em',
    textTransform: 'uppercase',
    color: CED_C_AMBER,
    '@media (max-width: 900px)': {
        fontSize: '9px',
        letterSpacing: '0.16em',
        gap: '6px',
        marginBottom: 0,
    },
};

const cedCircuitStatusDotStyle: React.CSSProperties = {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    backgroundColor: CED_C_AMBER,
    boxShadow: `0 0 0 2px rgba(240, 160, 32, 0.2), 0 0 10px ${CED_C_AMBER_DIM}`,
    flexShrink: 0,
};

const cedCircuitTitleStyle: React.CSSProperties = {
    position: 'relative',
    margin: '4px 0 0',
    fontFamily: "Impact, Haettenschweiler, 'Arial Narrow Bold', 'Franklin Gothic Condensed', sans-serif",
    fontSize: '33px',
    fontWeight: 400,
    letterSpacing: '0.06em',
    lineHeight: 0.95,
    textTransform: 'uppercase',
    color: CED_C_STEEL,
    '@media (max-width: 900px)': {
        fontSize: '22px',
        letterSpacing: '0.04em',
        marginTop: '2px',
        marginBottom: 0,
        lineHeight: 0.9,
    },
};

const cedCircuitSignalTrackStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',
    maxWidth: '420px',
    height: '7px',
    marginTop: '4px',
    overflow: 'hidden',
    '@media (max-width: 900px)': {
        height: '5px',
        marginTop: '2px',
        maxWidth: '100%',
    },
};

const cedCircuitSignalBaseStyle: React.CSSProperties = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50%',
    height: '1px',
    marginTop: '-0.5px',
    backgroundImage: `repeating-linear-gradient(90deg, ${CED_C_AMBER_DIM} 0 10px, transparent 10px 18px)`,
};

const cedCircuitSupportStyle: React.CSSProperties = {
    position: 'relative',
    margin: '2px 0 0',
    maxWidth: '34em',
    fontFamily: 'CenturyGothic, Arial, sans-serif',
    fontSize: '13px',
    fontWeight: 400,
    letterSpacing: '0.04em',
    lineHeight: 1.4,
    color: CED_C_STEEL_MUTED,
    '@media (max-width: 900px)': {
        fontSize: '11px',
        marginTop: '2px',
        lineHeight: 1.25,
        letterSpacing: '0.02em',
        maxWidth: '100%',
    },
};

const bannerImage: React.CSSProperties = {
    maxWidth: '45vw',
    maxHeight: '25vh',
};

/**
 * Full-bleed CED wood banner sized to the asset's 2400×280 aspect (~8.57:1).
 * Natural width scaling; no object-fit crop/stretch.
 */
const cedBannerWrap: React.CSSProperties = {
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 0,
    padding: 0,
    width: '100%',
    aspectRatio: '2400 / 280',
    lineHeight: 0,
    overflow: 'hidden',
};

const cedBannerImage: React.CSSProperties = {
    width: '100%',
    height: 'auto',
    display: 'block',
};

const cedCatalogCardStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '20px',
    maxWidth: '65vw',
    width: '100%',
    margin: '8px auto 28px',
    padding: '22px 26px',
    borderRadius: '16px',
    background: 'linear-gradient(135deg, #ffffff 0%, #f7fafc 100%)',
    border: '1px solid #e2e8f0',
    boxShadow: '0 8px 24px rgba(26, 54, 93, 0.08), 0 2px 6px rgba(0, 0, 0, 0.04)',
    fontFamily: 'CenturyGothic, Arial, sans-serif',
    textTransform: 'none',
    position: 'relative',
    overflow: 'hidden',
    '@media (max-width: 768px)': {
        flexDirection: 'column',
        textAlign: 'center',
        maxWidth: '95%',
        padding: '20px 18px',
        gap: '14px',
    },
};

const cedCatalogAccentStyle: React.CSSProperties = {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '4px',
    background: `linear-gradient(180deg, ${CED_NAVY} 0%, #3182ce 100%)`,
};

const cedCatalogIconWrapStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    backgroundColor: 'rgba(26, 54, 93, 0.08)',
    color: CED_NAVY,
};

const cedCatalogTextWrapStyle: React.CSSProperties = {
    flex: 1,
    minWidth: 0,
};

const cedCatalogHeadingStyle: React.CSSProperties = {
    margin: 0,
    fontSize: '18px',
    fontWeight: 600,
    color: '#1a202c',
    letterSpacing: '0.01em',
    lineHeight: 1.35,
};

const cedCatalogSubtextStyle: React.CSSProperties = {
    margin: '4px 0 0',
    fontSize: '14px',
    fontWeight: 400,
    color: '#718096',
    lineHeight: 1.45,
};

const cedCatalogButtonStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    flexShrink: 0,
    padding: '12px 22px',
    borderRadius: '999px',
    background: `linear-gradient(135deg, ${CED_NAVY} 0%, #2c5282 100%)`,
    color: '#ffffff',
    fontSize: '17px',
    fontWeight: 600,
    textDecoration: 'none',
    letterSpacing: '0.01em',
    whiteSpace: 'nowrap',
    boxShadow: '0 4px 12px rgba(26, 54, 93, 0.25)',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
    ':hover': {
        transform: 'translateY(-1px)',
        boxShadow: '0 6px 16px rgba(26, 54, 93, 0.32)',
        color: '#ffffff',
    },
    ':focus': {
        outline: '2px solid #63b3ed',
        outlineOffset: '2px',
        color: '#ffffff',
    },
    '@media (max-width: 768px)': {
        width: '100%',
        whiteSpace: 'normal',
    },
};

let errorStyle = Object.assign({}, Tgcc.Styles.error, { fontSize: '20px' });

class _MajorAccountsTVite extends React.Component<Tgcc.BaseProps, any> {
    state = {
        tvite: null,
        error: null,
        isWaiting: true,
        purchaseCompleted: false,
    };

    componentWillMount() {
        var proofId = this.props.location.query.proofId;
        var completed = this.props.location.query.completed;
        var isCompleted = completed !== undefined || completed === null;
        this.setState({ purchaseCompleted: isCompleted });
        Request.getTvite(proofId, this.tviteLoaded, this.loadError);
    }

    componentDidMount() {
        // Use 'setTimeout' to defer the scrolling until after the DOM has updated
        setTimeout(() => {
            const tag = document.getElementById('campusTvite');
            if (tag) {
                // If the element exists, then scroll it into view
                tag.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else {
                // If the element doesn't exist, handle that case here (e.g., log a warning)
                console.warn("Element with ID 'campusTvite' was not found.");
            }
        }, 0); // Timeout set to 0 to run after the browser has finished other processing
    }

    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    tviteLoaded = (info: Tgcc.TviteInfo) => {
        this.setState({ tvite: info, isWaiting: false });
    }

    loadError = (err: string) => {
        this.setState({ error: err, isWaiting: false });
        console.log("error loading tvite: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    getDashHeader() {
        const specialWebstore = this.state.tvite.specialWebstore;
        const proofId = this.state.tvite.proofId;
        const isCed = specialWebstore === 'CED';
        return (
            <div style={isCed ? cedBannerWrap : createAcc}>
                {specialWebstore === 'PapaJohns' ? (
                    // Display Papa John's banner
                    <img id='BULogo' style={bannerImage} src={Tgcc.ResolveUrl('~/images/PJBanner.png')} alt="Papa John's Logo" />
                ) : isCed ? (
                    <img id='BULogo' style={cedBannerImage} src={Tgcc.ResolveUrl('~/images/CEDBanner.png')} alt="CED Logo" />
                ) : specialWebstore === 'HBI' && (proofId === 'WO773171' || proofId === 'WO773246') ? (
                    // Display specific HBI banner for WO773171 and WO773246
                    <img id='BULogo' style={bannerImage} src={Tgcc.ResolveUrl('~/images/HBI-NoChamp-NoAlternative.jpeg')} alt="HBI Logo" />
                ) : specialWebstore === 'HBI' ? (
                    // Display default HBI banner for other HBI orders
                    <img id='BULogo' style={bannerImage} src={Tgcc.ResolveUrl('~/images/HBI-NEW.jpg')} alt="HBI Logo" />
                ) : (
                    // Default header with proofId
                    <div>
                        <div style={dashHdrLineR}></div>
                        <h1 style={dashText}>{this.state.tvite.proofId}</h1>
                        <div style={dashHdrLineL}></div>
                    </div>
                )}
            </div>
        )
    }

    /** CED industrial signal header with contact info. */
    getCedPageHeader() {
        return (
            <header id='tvite_header_style' style={cedCircuitWrapStyle} aria-label="CED Apparel Ordering">
                <div style={cedCircuitGridStyle} aria-hidden="true" />
                <div style={cedCircuitMainStyle}>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.35, ease: 'easeOut' }}
                        style={{ position: 'relative', width: '100%' }}
                    >
                        <p style={cedCircuitStatusStyle}>
                            <motion.span
                                aria-hidden="true"
                                style={cedCircuitStatusDotStyle}
                                animate={{ opacity: [1, 0.35, 1] }}
                                transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
                            />
                            Ordering Live
                        </p>
                        <h1 style={cedCircuitTitleStyle}>CED Apparel</h1>
                    </motion.div>
                    <div style={cedCircuitSignalTrackStyle} aria-hidden="true">
                        <div style={cedCircuitSignalBaseStyle} />
                        <motion.div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                width: '72px',
                                height: '2px',
                                marginTop: '-1px',
                                borderRadius: '1px',
                                background: `linear-gradient(90deg, transparent 0%, ${CED_C_AMBER} 40%, #ffd27a 70%, transparent 100%)`,
                                boxShadow: `0 0 8px ${CED_C_AMBER_DIM}`,
                            }}
                            animate={{ left: ['-18%', '108%'] }}
                            transition={{ duration: 2.4, repeat: Infinity, ease: 'linear', repeatDelay: 0.6 }}
                        />
                    </div>
                    <motion.p
                        initial={{ opacity: 0, y: 6 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: 0.12, ease: 'easeOut' }}
                        style={cedCircuitSupportStyle}
                    >
                        Pick your sizes, check out fast — catalog stays on the line.
                    </motion.p>
                </div>
                <aside style={cedCircuitContactStyle} aria-label="CED contact">
                    <div style={cedCircuitContactItemStyle}>
                        <p style={cedCircuitContactLabelStyle}>Call</p>
                        <a key="ced-contact-phone" href="tel:18004723269" style={cedCircuitContactLinkStyle}>1-800-472-3269</a>
                    </div>
                    <div style={cedCircuitContactItemStyle}>
                        <p style={cedCircuitContactLabelStyle}>Email</p>
                        <a key="ced-contact-email" href="mailto:sales@grafcow.com" style={cedCircuitContactLinkStyle}>sales@grafcow.com</a>
                    </div>
                </aside>
            </header>
        );
    }

    getCedCatalogStrip() {
        const { tvite } = this.state;
        if (tvite?.specialWebstore !== 'CED' || !tvite.catalogUrl) {
            return null;
        }

        return (
            <div style={cedCatalogCardStyle} role="region" aria-label="CED apparel catalog">
                <div style={cedCatalogAccentStyle} aria-hidden="true" />
                <div style={cedCatalogIconWrapStyle} aria-hidden="true">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4 5.5C4 4.67 4.67 4 5.5 4H18.5C19.33 4 20 4.67 20 5.5V18.5C20 19.33 19.33 20 18.5 20H5.5C4.67 20 4 19.33 4 18.5V5.5Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                        />
                        <path d="M8 4V20M16 4V20" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M4 9H20M4 15H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                </div>
                <div style={cedCatalogTextWrapStyle}>
                    <p style={cedCatalogHeadingStyle}>Looking for more?</p>
                    <p style={cedCatalogSubtextStyle}>Browse our full custom CED design &amp; apparel catalog for additional styles.</p>
                </div>
                <a
                    key="ced-catalog-guide"
                    href={tvite.catalogUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={cedCatalogButtonStyle}
                >
                    Custom CED guide
                    <span aria-hidden="true">↗</span>
                </a>
            </div>
        );
    }

    render() {
        var completed = this.state.purchaseCompleted;
        var error = this.state.error ? <div style={errorStyle}>{this.state.error}</div> : null;
        var tvite = this.state.tvite;
        var content = null;
        if (tvite) {
            // Determine the header text based on the weborder value
            var headerText = '';
                    if (this.state.tvite.proofId === 'WO773171' || this.state.tvite.proofId === 'WO773246') {
            headerText = "Redeem Your Free Sales Kit!";
        } else if (this.state.tvite.proofId === 'WO742676') {
                headerText = "Redeem your Free T-Shirt";
            } else if (this.state.tvite.proofId === 'WO742789') {
                headerText = "Welcome to the Shirt of the Month Club!";
            } else if (this.state.tvite.specialWebstore === 'CED') {
                headerText = "Welcome to CED Apparel Ordering";
            } else {
                headerText = "Welcome to \"T-Vite\", an Apparel Order Portal";
            }

            // Determine the subheader text based on the weborder value
            var subHeaderText = '';
                    if (this.state.tvite.proofId === 'WO773171' || this.state.tvite.proofId === 'WO773246') {
            subHeaderText = "🎁 KIT INCLUDES: (1) Hanes 5280, (1) Hanes 4980, (1) Hanes 5180, and Hanes Good, Better, Beefy Product Brochure 📋";
        } else if (this.state.tvite.proofId === 'WO742676') {
                subHeaderText = "Redeem your Free T-Shirt!";
            } else if (this.state.tvite.proofId === 'WO742789') {
                subHeaderText = "Join the Shirt of the Month Club!";
            } else if (this.state.tvite.specialWebstore === 'CED') {
                subHeaderText = "Select your sizes and check out. Browse the full catalog anytime.";
            } else {
                subHeaderText = "Select Your Sizes and Check Out Seamlessly";
            }

            const isCed = this.state.tvite.specialWebstore === 'CED';
            content = (
                <div
                    style={isCed ? cedPageWrapperStyle : wrapperStyle}
                    className={isCed ? 'cedTviteBox' : 'campusTviteBox'}
                >
                    {isCed ? (
                        this.getCedPageHeader()
                    ) : (
                        <React.Fragment>
                            <div id='tvite_header_style' style={headerStyle}>{headerText}</div>
                            <div style={subHeaderStyle}>{subHeaderText}</div>
                        </React.Fragment>
                    )}
                    {this.getDashHeader()}
                    <TViteProofCard tvite={tvite} />
                    {this.getCedCatalogStrip()}
                    <TVitePurchase tvite={tvite} purchaseComplete={completed} />
                </div>
            );
        } else {
            content = (
                <div style={wrapperStyle}>
                    <div style={Tgcc.Styles.error}>{this.state.error}</div>
                </div>
            );
        }

        return (
            <div>
                <div id='majorTvite'></div>
                {content}
            </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state }
};

export var MajorAccountsTVite = connect(mapStateToProps)(Radium(_MajorAccountsTVite));
